import React from 'react';
// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useAuth } from 'contexts/AuthContext';
import { filterMenuByPermissions } from 'hooks/usePermissions.jsx';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { user } = useAuth();
  const location = useLocation();
  
  // Filtrar elementos del menú según el rol del usuario
  const filteredMenuItems = React.useMemo(
    () => filterMenuByPermissions(menuItem.items, user?.role),
    [location.pathname, user?.role]
  );
  
  const navGroups = filteredMenuItems.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
